module.exports = "/_next/static/images/contact_4-891c4f1e1638b62d58cb87ab52153248.png";